
export const DOWNLOAD_COUNT = {
  free_down_cnt: 0,
  down_cnt: 0,
  day_free_limit: 0,
  today_free_down: 0,
  free_remain: 0,
}
